<ng-container *ngIf="title">
  <h3>{{ title }}</h3>
</ng-container>
<div class="loading-shade" *ngIf="isBusy">
  <mat-spinner *ngIf="isBusy"></mat-spinner>
</div>
<table mat-table [dataSource]="dataSource">
  <ng-container matColumnDef="result">
    <th mat-header-cell *matHeaderCellDef>Result</th>
    <td [style.max-width]="'35vw'" mat-cell *matCellDef="let row">
      <div *ngFor="let m of row.matches">
        <span [style.margin-right.px]="4" [style.font-weight]="600">
          {{ m.label || m.fieldId }}:
        </span>
        <span [innerHtml]="m.value | highlight : term"> </span>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="module">
    <th mat-header-cell *matHeaderCellDef>Module</th>
    <td
      mat-cell
      *matCellDef="let row"
      [innerHtml]="row.module.name | highlight : term"
    ></td>
  </ng-container>
  <ng-container matColumnDef="date">
    <th mat-header-cell *matHeaderCellDef>Updated Date</th>
    <td
      mat-cell
      *matCellDef="let row"
      [innerHtml]="(row.date | date : dateFormat) + '' | highlight : term"
    ></td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="columnDefs"></tr>
  <tr
    mat-row
    (click)="itemClick.emit({ event: $event, item: row })"
    *matRowDef="let row; columns: columnDefs"
  ></tr>
</table>
<mat-paginator [length]="dataSource.data.length" [pageSize]="pageSize">
</mat-paginator>
